import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import TradeZakatTable from "./TradeZakatTable";
import { SERVER_URL } from "./ConstantsIslamicCalculator";
import { Trade_Zakat_EndPoint } from "./ConstantsIslamicCalculator";
import SharedHelmet from "../Helmet";
const TITLE = "حاسبة زكاة عروض التجارة - احسب زكاة عروضك التجارية بدقة";
const DESCRIPTION =
  "حاسبة زكاة التجارة هي أداة حسابية مصممة لتسهيل عملية حساب مبلغ الزكاة المستحقة على أموال التجارة وفقًا للمبادئ الشرعية. تهدف الحاسبة إلى توفير حل سريع ودقيق للأفراد والتجار الذين يرغبون في تحديد المبلغ المستحق للزكاة وفقًا للمعايير الشرعية المعتمدة.";
const KEYWORDS = "زكاة التجارة, زكاة عروض التجارة ";
const OG_URL = "https://do-calculate.com/calculator/ar/trade-zakat/";
const apiEndpoint = `${SERVER_URL}/${Trade_Zakat_EndPoint}`;
function TradeZakatCalculator() {
  const [cash, setCash] = useState(0);
  const [yearType, setYearType] = useState("");
  const [gramPriceGold, setGramPriceGold] = useState(0);
  const [gramPriceSilver, setGramPriceSilver] = useState(0);
  const [debtsReceivable, setDebtsReceivable] = useState(0);
  const [debtsPayable, setDebtsPayable] = useState(0);
  const [merchandise, setMerchandise] = useState(0);
  const [result, setRestul] = useState(null);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [classification, setClassification] = useState(null);
  const [thresholdType, setThresholdType] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const handleThresholdTypeChange = (event) => {
    const newThresholdType = event.target.value;
    setThresholdType(newThresholdType);
    if (newThresholdType === "gold") {
      setGramPriceSilver(0);
    } else if (newThresholdType === "silver") {
      setGramPriceGold(0);
    }
  };
  const handleYearTypeChange = (event) => {
    setYearType(event.target.value);
  };
  const handleCashChange = (event) => {
    setCash(event.target.value);
  };
  const handleDebtsReceivableChange = (event) => {
    setDebtsReceivable(event.target.value);
  };
  const handleMerchandiseChange = (event) => {
    setMerchandise(event.target.value);
  };
  const handleDebtsPayableChange = (event) => {
    setDebtsPayable(event.target.value);
  };
  const handleGramPriceGoldChange = (event) => {
    setGramPriceGold(event.target.value);
  };
  const handleGramPriceSilverChange = (event) => {
    setGramPriceSilver(event.target.value);
  };
  const calculateTradeZakat = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          merchandise,
          cash,
          debtsReceivable,
          debtsPayable,
          yearType,
          gramPriceGold,
          gramPriceSilver,
        }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setRestul(data.result);
        setError(null);
        setClassification(data.result.classification);
      } else {
        setRestul(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>إحسب زكاة عروض التجارة</h1>
          </div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                حاسبة زكاة التجارة هي أداة حسابية مصممة لتسهيل عملية حساب مبلغ الزكاة المستحقة على أموال التجارة وفقًا للمبادئ الشرعية. تهدف الحاسبة إلى توفير حل سريع ودقيق للأفراد والتجار الذين يرغبون في تحديد المبلغ المستحق للزكاة وفقًا للمعايير الشرعية المعتمدة.
                                <br />
                                <hr />
                            </div>
                            <br />
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-5 calculatorStyle">
                                <div className='p-3 mb-2 bg-success text-white'>
                                    زكاة عروض التجارة
                                </div>
                                <hr />
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='yearType' >نوع الحول</label>
                                    </b>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            name="yearType"
                                            value="gregorian"
                                            id="gregorian"
                                            checked={yearType === "gregorian"}
                                            onChange={handleYearTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="gregorian">
                                            ميلادي
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            name="yearType"
                                            id="hijri"
                                            value="hijri"
                                            checked={yearType === "hijri"}
                                            onChange={handleYearTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="hijri">
                                            هجري
                                        </label>
                                    </div>
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='merchandiseNumber' className="form-label ms-2">عروض التجارة </label>
                                    </b>
                                    <input
                                        type="number"
                                        id="merchandiseNumber"
                                        value={merchandise}
                                        onChange={handleMerchandiseChange}
                                        className="form-control ml-2"
                                        style={{ width: '90%' }}
                                    />
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='cashNumber' className="form-label ms-2">إجمالي المال (النقد)</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="cashNumber"
                                        value={cash}
                                        onChange={handleCashChange}
                                        className="form-control ml-2"
                                        style={{ width: '90%' }}
                                    />
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='debtsReceivableNumber' className="form-label ms-2">الديون مرجوة السداد</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="debtsReceivableNumber"
                                        value={debtsReceivable}
                                        onChange={handleDebtsReceivableChange}
                                        className="form-control ml-2"
                                        style={{ width: '90%' }}
                                    />
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='debtsPayableNumber' className="form-label ms-2">الديون التي على التاجر</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="debtsPayableNumber"
                                        value={debtsPayable}
                                        onChange={handleDebtsPayableChange}
                                        className="form-control ml-2"
                                        style={{ width: '90%' }}
                                    />
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='thresholdType' >نوع النصاب</label>
                                    </b>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            name="thresholdType"
                                            value="gold"
                                            id="gold"
                                            checked={thresholdType === "gold"}
                                            onChange={handleThresholdTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="gold">
                                            ذهب
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            name="thresholdType"
                                            value="silver"
                                            id="silver"
                                            checked={thresholdType === "silver"}
                                            onChange={handleThresholdTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="silver">
                                            فضة
                                        </label>
                                    </div>
                                </div>
                                <br />
                                {thresholdType === "gold" && (
                                    <div className="form-group d-flex align-items-center">
                                        {gramPriceSilver == 0}
                                        <b>
                                            <label htmlFor='gramPriceGoldNumber' className="form-label ms-2">سعر غرام الذهب (24 قيراط)</label>
                                        </b>
                                        <input
                                            type="number"
                                            id="gramPriceGoldNumber"
                                            value={gramPriceGold}
                                            onChange={handleGramPriceGoldChange}
                                            className="form-control ml-2"
                                            style={{ width: '90%' }}
                                        />
                                    </div>
                                )}
                                {thresholdType === "silver" && (
                                    <div className="form-group d-flex align-items-center">
                                        {gramPriceGold == 0}
                                        <b>
                                            <label htmlFor='gramPriceSilverNumber' className="form-label ms-2">سعر غرام الفضة (عيار 99.9)</label>
                                        </b>
                                        <input
                                            type="number"
                                            id="gramPriceSilverNumber"
                                            value={gramPriceSilver}
                                            onChange={handleGramPriceSilverChange}
                                            className="form-control ml-2"
                                            style={{ width: '150px' }}
                                        />
                                    </div>
                                )}
                                <br/>                                <hr />
                <button
                  className="btn btn-success"
                  style={{ fontSize: "20px" }}
                  onClick={calculateTradeZakat}
                       >
                    احسب
                    </button>              </div>
              <div className="col-12 col-md-7">
                <br />
                {statusCode === 400 && (
                  <div className="alert alert-warning">
                    <b>
                      <u> حدث خطأ :</u>
                    </b>{" "}
                    يُرجى إدخال جميع الحقول بالشكل الصحيح.{" "}
                  </div>
                )}
                {result && (
                  <div>
                    <h4>
                      <div className="p-3 mb-2 bg-success text-white">
                        النتائج:{" "}
                      </div>
                    </h4>
                    <hr />
                    <TradeZakatTable result={result}></TradeZakatTable>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">وصف حاسبة زكاة عروض التجارة </div>
              <div className="info-section-body">
                <u>
                  <b> حاسبة عروض التجارة </b>{" "}
                </u>{" "}
                <br/>                حاسبة زكاة التجارة هي أداة تستخدم لحساب مبلغ الزكاة المستحقة على
                أموال التجارة. تم تطوير الحاسبة لتأخذ في الاعتبار البضائع
                المملوكة، النقد، الديون المستحقة للتجار والديون المستحقة منهم،
                نوع السنة الزمنية (هجري أو ميلادي)، وأسعار الذهب والفضة لحساب
                الحد الأدنى للمال المستحق للزكاة. تستند الحاسبة إلى قواعد شرعية
                محددة لحساب المبلغ المستحق للزكاة بنسبة مئوية محددة من قيمة
                الأموال.
                <br/>                تتضمن حاسبة زكاة التجارة عدة مكونات ومعايير لحساب الزكاة بشكل
                صحيح. البيانات الأساسية التي يتم إدخالها في الحاسبة تشمل:
                <ul>
                  <li>
                    البضائع المملوكة: قيمة البضائع التجارية المملوكة للتاجر في
                    الفترة المحددة، وتشمل البضائع المخزنة والمباعة والمشتراة.
                  </li>
                  <li>
                    النقد: قيمة الأموال النقدية المملوكة للتاجر في الحسابات
                    البنكية أو النقدية المتاحة للدفع.
                  </li>
                  <li>
                    الديون المستحقة للتجار: المبالغ المستحقة للتجار والموردين
                    والتي لم يتم سدادها حتى الآن.
                  </li>
                  <li>
                    الديون المستحقة من التجار: المبالغ المستحقة من العملاء
                    والمشترين والتي لم يتم استلامها حتى الآن.
                  </li>
                  <li>
                    نوع السنة الزمنية: يتم تحديد السنة الزمنية لحساب الزكاة،
                    سواء كانت هجرية أو ميلادية.
                  </li>
                  <li>
                    أسعار الذهب والفضة: تُستخدم أسعار الذهب والفضة الحالية لحساب
                    الحد الأدنى للمال المستحق للزكاة. يعتمد ذلك على الوزن
                    المعياري للذهب والفضة وقيمتها بحسب الوزن.
                  </li>
                </ul>
                <br/>                بعد إدخال هذه البيانات، تقوم الحاسبة بتحويلها إلى أرقام وتقوم
                بحساب الحد الأدنى للمال المستحق للزكاة بناءً على أسعار الذهب
                والفضة المعطاة. ثم تُحسب الزكاة بنسبة مئوية محددة من قيمة
                الأموال المحسوبة بناءً على القواعد الشرعية. تعرض الحاسبة النتائج
                المحسوبة بشكل واضح مثل مبلغ الزكاة المستحقة والأموال المستحقة
                والحد الأدنى المحسوب.
                <br/>                تتيح حاسبة زكاة التجارة للأفراد والتجار إمكانية حساب الزكاة
                بسهولة وسرعة، مما يساعدهم على الامتثال للمبادئ الشرعية والقواعد
                الضرورية لدفع الزكاة. يمكن استخدام الحاسبة في تطبيقات الهواتف
                الذكية أو المواقع الإلكترونية أو البرامج المخصصة لحساب زكاة
                التجارة، مما يوفر راحة ودقة في عملية حساب الزكاة ويعزز الامتثال
                للمتطلبات الشرعية.
                <br />
                <hr />
                <b>تاريخ اخر مراجعة : </b>
                28/02/2026
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default TradeZakatCalculator;
